import { useEffect, useState } from "react";
import axios from "axios";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { getDeviceId, saveHelperSession, helperLandingPath } from "@/pages/FestivalHelperRedeem";
import { safeReplace } from "@/lib/safeNavigate";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const ROLE_NAMES = {
  check_in_helper: "Check-In Helper", roster_ops_helper: "OPS Assist", court_ops_helper: "Court Operations",
  deputy_helper: "Deputy Admin", festival_only_helper: "Organiser",
};

export function HelperModeSwitch({ festivalId, token, verifyKey }) {
  const [pass, setPass] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!verifyKey) return;
    axios.get(`${BACKEND}/api/festival/${festivalId}/self-service/${token}/helper-pass?vk=${encodeURIComponent(verifyKey)}`)
      .then((r) => setPass(r.data?.available ? r.data : null))
      .catch(() => setPass(null));
  }, [festivalId, token, verifyKey]);

  if (!pass) return null;
  const roleLabel = ROLE_NAMES[pass.role] || "Helper";

  const switchToHelper = async () => {
    setBusy(true);
    try {
      const r = await axios.post(
        `${BACKEND}/api/festival/${festivalId}/self-service/${token}/helper-mode?vk=${encodeURIComponent(verifyKey)}`,
        { device_id: getDeviceId() },
      );
      saveHelperSession({
        festivalId, passId: r.data.pass_id, token: r.data.helper_token, role: r.data.role,
        label: r.data.label, expiresAt: r.data.expires_at,
        playerReturn: window.location.pathname,
      });
      safeReplace(helperLandingPath(festivalId, r.data.role));
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't switch to Helper Mode");
      setBusy(false);
    }
  };

  return (
    <button type="button" onClick={switchToHelper} disabled={busy} data-testid="ss-switch-helper-mode"
      className="w-full mb-4 inline-flex items-center justify-center gap-2 px-4 py-3 text-xs uppercase tracking-widest font-bold border-2 border-[#66C2FF] text-[#66C2FF] hover:bg-[#66C2FF] hover:text-black transition-colors disabled:opacity-50">
      <ShieldCheck className="w-4 h-4" />
      {busy ? "Switching…" : `Switch to Helper Mode · ${roleLabel}`}
    </button>
  );
}

export default HelperModeSwitch;
